import snakeCase from 'lodash/snakeCase'
import { useConfig } from 'builder/hooks/useConfig'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { SectionNames, selectors } from 'builder/modules/resumeEditor'
import { WORK_EXPERIENCE_ANALYTICS_SECTION_NAME } from '../constants'

export const useStepByStepFeature = () => {
  const config = useConfig()
  const currentStep = useTypedSelector(selectors.stepByStepFlowCurrentStep)
  const isRbpStepFlowFeatureEnabled = !!config?.features.rbpStepFlow
  const isRbpStepFlowActive = !!currentStep && isRbpStepFlowFeatureEnabled

  const currentStepEventName = currentStep
    ? currentStep === SectionNames.workExperiences
      ? WORK_EXPERIENCE_ANALYTICS_SECTION_NAME
      : snakeCase(currentStep as string)
    : null

  return {
    isRbpStepFlowActive,
    isRbpStepFlowFeatureEnabled,
    currentStep,
    currentStepEventName,
  }
}
